import React from 'react';
import { useSelector } from 'react-redux';
import './style.scss';
import { Button, Hamburger, Icon } from '../../components';
import colors from '../../utils/colors';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { APP_ROUTES } from '../../routing/ROUTES';
import { useDidUpdate } from 'rooks';

function MobileMenu({ active, toggleMenu }) {
	const state = useSelector((state) => state);
	const history = useHistory();
	const location = useLocation();

	const handleClickLogout = () => {
		history.push('/logout');
	};

	useDidUpdate(toggleMenu, [location]);

	return (
		<div className={`mobile-menu ${active ? 'active' : ''}`}>
			<header className="logo">
				<Icon name="logo" width="90px" height="30px" color={colors.white} />
				<h1>Generator testów</h1>
			</header>
			<Hamburger
				active={active}
				toggle={() => {
					toggleMenu(!active);
				}}
			/>
			<main className="mobile-menu-body">
				<nav>
					<ul>
						{APP_ROUTES?.sort((a, b) => a.order - b.order)?.map((r) => (
							<li key={r.id}>
								<Link to={r.path}>{r.label}</Link>
							</li>
						))}
					</ul>
				</nav>
				<div className="account">
					{!state.user.demo ? (
						<Button
							color="transparent text-primary"
							onClick={() => {
								window.open('http://konto.operon.pl', '_blank');
							}}
						>
							<Icon name="user" width="24" height="24" color={colors.white} />
							<span>Moje konto</span>
							<span className="mobile-menu-email">{state.user.email}</span>
						</Button>
					) : (
						<p className="mobile-demo-version-info">wersja demo</p>
					)}

					<Button color="transparent text-primary" onClick={handleClickLogout}>
						<Icon name="logout" width="24" height="24" color={colors.white} />
						Wyloguj się
					</Button>
				</div>
			</main>
			<footer>
				<a href="https://konto.operon.pl/regulamin">Regulamin</a>
				<a href="https://operon.pl/O-Nas/Polityka-prywatnosci">Polityka prywatności</a>
			</footer>
		</div>
	);
}

export default MobileMenu;
